export const EN: Record<string, string> = {
  "Recommended for you": "Recommended for you",
  "Resource added to favorite": "Resource added to favorite",
  "Failed to add resource to favorite": "Failed to add resource to favorite",
  "Resource removed from favorite": "Resource removed from favorite",
  "Failed to remove resource from favorite": "Failed to remove resource from favorite",
  Calendar: "Calendar",
  "View Detail": "View Detail",
  "Add to favorites": "Add to favorites",
  "Description: VIP meeting room with a great view and comfortable chairs.":
    "Description: VIP meeting room with a great view and comfortable chairs.",

  // NoResultFound
  "There are no available resources at the chosen time at your location or in your favorites.":
    "There are no available resources at the chosen time at your location or in your favorites.",
  "You have these options:": "You have these options:",
  "Change the meeting time.": "Change the meeting time.",
  "Use the <1>Find Available Time</1> button to choose a new time.":
    "Use the <1>Find Available Time</1> button to choose a new time.",
  "Open the search to find other resources.": "Open the search to find other resources.",

  // ResourceCard
  "New Order": "New Order",
  "Change Order": "Change Order",
  "Move Order": "Move Order",
  "When booking a Pooled Resource, only this resource type and only one can be booked.":
    "When booking a Pooled Resource, only this resource type and only one can be booked.",
  "You cannot select both a child resource and its virtual resource at the same time.":
    "You cannot select both a child resource and its virtual resource at the same time.",
  // Settings
  "Note:": "Note:",
  "An Assistant Organizer can receive the same emails from Resource Central as the organizer and can handle orders on behalf of the organizer.":
    "An Assistant Organizer can receive the same emails from Resource Central as the organizer and can handle orders on behalf of the organizer.",
  "Setting updated successfully": "Setting updated successfully",
  "Setting updated failed": "Setting updated failed",
  "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)": "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)",
  "It is not possible to order services on the selected resource.": "It is not possible to order services on the selected resource.",

  // ModalResourceDetail
  "Opening hours:": "Opening hours:",
  "Buffer time {{minutes}} mins between reservations": "Buffer time {{minutes}} mins between reservations",
  "Initial payment {{value}} pr.minute": "Initial payment {{value}} pr.minute",
  "Cost initial": "Cost initial",
  "Cost per minute": "Cost per minute",

  // FindAvailableTime
  "Total {{total}} Attendees": "Total {{total}} Attendees",
  "{{internal}} of {{total}} internal can attend.": "{{internal}} of {{total}} internal can attend.",
  "{{external}} external is unknown.": "{{external}} external is unknown.",
  "Find available time": "Find available time",
  Attendees: "Attendees",

  // HelpSetting
  "Click on Further information to visit our support site": "Click on Further information to visit our support site",
  "Further information": "Further information",

  // LocationSetting
  "Location changed": "Location changed",
  "Location change failed": "Location change failed",
  "Please select at least one location": "Please select at least one location",
  "Resource types": "Resource types",
  Location: "Location",
  Where: "Where",

  // ModalShowAttendees
  Total: "Total",
  Available: "Available",
  Busy: "Busy",
  External: "External",
  Internal: "Internal",

  // ResourceSearch
  "Search by resource name": "Search by resource name",
  Category: "Category",
  "Filter by Location": "Filter by Location",
  "Filter by Category": "Filter by Category",
  Capacity: "Capacity",
  "Filter by Capacity": "Filter by Capacity",
  All: "All",
  "Filter by availability": "Filter by availability",
  "Sort By": "Sort By",
  "Loading...": "Loading...",

  // SelectedResources
  "Meeting Type": "Meeting Type",
  "Meeting Label": "Meeting Label",

  // Alert (accessibility text)
  "Check icon": "Check icon",
  Close: "Close",

  // AppConstants - searchTab
  Resource: "Resource",
  Person: "Person",

  // AppConstants - listQuestionsStart
  "Where do your meetings usually take place?": "Where do your meetings usually take place?",
  "To improve our recommendations for you we would like you to enter your normal location":
    "To improve our recommendations for you we would like you to enter your normal location",
  "What do you use most?": "What do you use most?",
  "To enable quicker and better search please chose you prefered resource type":
    "To enable quicker and better search please chose you prefered resource type",

  // AppConstants - titlePages
  "Click on resource to pick": "Click on resource to pick",
  "Selected Resources": "Selected Resources",
  Setting: "Setting",
  Search: "Search",
  "Find Colleague": "Find Colleague",
  "Quick button setting": "Quick button setting",
  Favorite: "Favorite",
  "Most Used": "Most Used",
  Colleagues: "Colleagues",
  Resources: "Resources",

  // AppConstants - tooltipText
  "Availability": "Availability",
  "Available occurrences of the series": "Available occurrences of the series",
  "Conflicting Occurrences": "Conflicting Occurrences",
  "Unavailable Occurrences": "Unavailable Occurrences",
  Back: "Back",
  "Floor Plan": "Floor Plan",
  Expand: "Expand",
  "Selected resources": "Selected resources",
  "View details": "View details",
  "Remove from My Favorites": "Remove from My Favorites",
  "Add to My Favorites": "Add to My Favorites",
  Remove: "Remove",
  "Favorite - Most Used": "Favorite - Most Used",
  Conflict: "Conflict",
  Approved: "Approved",
  Agent: "Agent",
  "Recommendeded for you": "Recommendeded for you",
  "Find colleague (Not available for recurring meetings)": "Find colleague (Not available for recurring meetings)",

  // Agent
  "Find resource": "Find resource",
  "Find colleague": "Find colleague",
  "Floor plan": "Floor plan",
  Today: "Today",
  "Here is your list resource in the {{location}}": "Here is your list resource in the {{location}}",
  "Hi there. How can I help you today?": "Hi there. How can I help you today?",
  "Find your resource...": "Find your resource...",
  "Find resources available in {{location}}": "Find resources available in {{location}}",

  // AppConstants - mailFlowOptions
  "Only primary organizer": "Only primary organizer",
  "Only assistant organizer": "Only assistant organizer",
  "Primary AND assistant organizer": "Primary AND assistant organizer",

  // FindColleague
  "Enter colleague name": "Enter colleague name",
  "Recent work items": "Recent work items",
  "No data available": "No data available",
  Floorplan: "Floorplan",
  "List nearby resources": "List nearby resources",
  "Find resource nearby": "Find resource nearby",
  "No Resources available": "No Resources available",

  // Start page
  Next: "Next",
  "Failed to update default locations": "Failed to update default locations",
  "Resource Type": "Resource Type",

  // QuickSetting
  "Quick buttons updated successfully": "Quick buttons updated successfully",
  "Quick buttons updated failed": "Quick buttons updated failed",
  "Add more": "Add more",
  Apply: "Apply",
  Delete: "Delete",
  Name: "Name",
  "Enter name": "Enter name",
  Tooltip: "Tooltip",
  "Enter tooltip": "Enter tooltip",
  Type: "Type",
  "Select type": "Select type",
  Locations: "Locations",
  "Select colleagues": "Select colleagues",
  "Select resources": "Select resources",

  // DefaultResourceSetting
  "Resource type changed": "Resource type changed",
  "Resource type change failed": "Resource type change failed",
  "Default Resource Type": "Default Resource Type",

  // AssistantOrganizerSetting
  "Apply Successfully": "Apply Successfully",
  "Apply Failed": "Apply Failed",
  "Assistant Organizer": "Assistant Organizer",
  "Enter a part of the name to search for": "Enter a part of the name to search for",
  "Mail Flow": "Mail Flow",
  "Select Mail Flow": "Select Mail Flow",

  // TileConfigurationSetting
  "Update settings successfully": "Update settings successfully",
  "Update settings failed": "Update settings failed",
  Timeline: "Timeline",

  // SelectCategoryForm
  And: "And",
  Or: "Or",

  // Other
  "Resource Calendar": "Resource Calendar",

  // SettingLabels
  "Default Location": "Default Location",
  "Quick button": "Quick button",
  "Category icons": "Category icons",
  "Recommendation screen": "Recommendation screen",
  "Capacity filter": "Capacity filter",
  "AI Assistant": "AI Assistant",
  "Tile configuration": "Tile configuration",
  Help: "Help",
  "Default Categories": "Default Categories",

  // MeetingType
  "Your must select a Meeting label": "Your must select a Meeting label",

  // AlternativeResource
  "Selected Resource: {{resourceName}} Conflicting Occurrences":
    "Selected Resource: {{resourceName}} Conflicting Occurrences",
  "Alternative Resource": "Alternative Resource",
  OK: "OK",
  Cancel: "Cancel",

  // RemovedResource
  "Your selected resource {{resourceName}} was removed from the meeting due to the following conflict:":
    "Your selected resource {{resourceName}} was removed from the meeting due to the following conflict:",
  "You can't book this resource as your request exceeds the available capacity.":
    "You can't book this resource as your request exceeds the available capacity.",

  //OpenOrderForm
  "If you select 'Yes' the order will be transferred to the resource you have selected. If you select 'No', the order will be canceled.":
    "If you select 'Yes' the order will be transferred to the resource you have selected. If you select 'No', the order will be canceled.",
  "If you select 'Yes', the available parts of the order will be move to the new resource.":
    "If you select 'Yes', the available parts of the order will be move to the new resource.",
  "If you select 'No' the order will be cancelled when moving the meeting to the new resource.":
    "If you select 'No' the order will be cancelled when moving the meeting to the new resource.",
    "If you select 'No', the order will be cancelled when moving the meeting to the new resource.":
    "If you select 'No', the order will be cancelled when moving the meeting to the new resource.",
  "You are moving your meeting to another resource.<1></1><1></1>The new resource may not offer the same items and/or extra services, or some of the items may not be available due to deadlines. Please check the new order , to see the impact":
    "You are moving your meeting to another resource.<1></1><1></1>The new resource may not offer the same items and/or extra services, or some of the items may not be available due to deadlines. Please check the new order , to see the impact",
  "If you select 'Yes', the available parts of the order will be moved to the new resource. Additional order changes can be done when the order has been moved.":
    "If you select 'Yes', the available parts of the order will be moved to the new resource. Additional order changes can be done when the order has been moved.",
  "The order in the reservation you are moving cannot be moved because the deadline for ordering services has passed.<1></1>Do you still want to proceed ?":
    "The order in the reservation you are moving cannot be moved because the deadline for ordering services has passed.<1></1>Do you still want to proceed ?",
  "You are moving the meeting to another resource.<1/>The new resource may not offer the same items and/or extra services, or some of the items may not be available due to deadlines. Please check the new order to see the impact.":
    "You are moving the meeting to another resource.<1/>The new resource may not offer the same items and/or extra services, or some of the items may not be available due to deadlines. Please check the new order to see the impact.",
  "You are moving your meeting to another resource. Do you also want to move your order?":
    "You are moving your meeting to another resource. Do you also want to move your order?",
  "You are moving your meeting to another resource.<1/><1/>The new resource does not have the same items and/or extra services, or some of the items might be inactive.<1/><1/>Do you want to create an order for the new resource?":
    "You are moving your meeting to another resource.<1/><1/>The new resource does not have the same items and/or extra services, or some of the items might be inactive.<1/><1/>Do you want to create an order for the new resource?",
  "You are moving your meeting to another resource.<1/><1/>The existing order will be cancelled because ordering is not possible at this location due to a holiday.<1/><1/>Do you want to proceed?":
    "You are moving your meeting to another resource.<1/><1/>The existing order will be cancelled because ordering is not possible at this location due to a holiday.<1/><1/>Do you want to proceed?",
  "You are moving your meeting to another resource.<1/><1/>The existing order will be cancelled because the new resource does not support ordering.<1/><1/>Do you want to proceed?":
    "You are moving your meeting to another resource.<1/><1/>The existing order will be cancelled because the new resource does not support ordering.<1/><1/>Do you want to proceed?",
 "As this is a Recurring meeting, please use 'My Meetings', the individual Outlook meeting of the series or the Recurring reservation or order email to handle the orders for this series.":
    "As this is a Recurring meeting, please use 'My Meetings', the individual Outlook meeting of the series or the Recurring reservation or order email to handle the orders for this series.",
    // ChangeTime
  "Time changed successfully": "Time changed successfully",
  "Current Time": "Current Time",
  "Suggested Times": "Suggested Times",
  "Change Time": "Change Time",
  "All attendees internal are free": "All attendees internal are free",
  "{{quantity}} people are free": "{{quantity}} people are free",

  //permission
  "Closed Period": "Closed Period",
  "Closing Date": "Closing Date",
  "Opening Date": "Opening Date",
  "None": "None",
  "Prioritized Reservation": "Prioritized Reservation",
  "Closed": "Closed",
  "Booking policy": "Booking policy",
  "Reason": "Reason",
  "This resource can be booked. Be aware that the resource will not be booked on the occurencies with conflicts.":
    "This resource can be booked. Be aware that the resource will not be booked on the occurencies with conflicts.",
  "This resource can be booked. Beware that the resource will not be booked on the occurrences where the available capacity is exceeded.":
    "This resource can be booked. Beware that the resource will not be booked on the occurrences where the available capacity is exceeded.",
  "This resource can be booked but for occurrences with conflicts the resource will not be booked.":
    "This resource can be booked but for occurrences with conflicts the resource will not be booked.",
  "This resource cannot be booked because the booking does not comply with the resource booking policies.":
    "This resource cannot be booked because the booking does not comply with the resource booking policies.",
  "Booking this resource requires approval by the resource's delegate. Your request will be forwarded, pending approval.":
    "Booking this resource requires approval by the resource's delegate. Your request will be forwarded, pending approval.",
  "You do not have permission to book this resource.": "You do not have permission to book this resource.",
  "Booking this resource is blocked due to an error in the configuration. Please contact your IT-department.":
    "Booking this resource is blocked due to an error in the configuration. Please contact your IT-department.",
  "This resource is reserved. If it is not booked, the resource will be free for all to book {{daysReserved}} days before the desired reservation date.":
    "This resource is reserved. If it is not booked, the resource will be free for all to book {{daysReserved}} days before the desired reservation date.",
  "You cannot book this resource because your meeting request conflicts with the resource's booking policies.":
    "You cannot book this resource because your meeting request conflicts with the resource's booking policies.",
  "This resource can be booked, but please be aware of the Prioritized Reservations for this resource on the following days: {{days}}":
    "This resource can be booked, but please be aware of the Prioritized Reservations for this resource on the following days: {{days}}",
    "A resource can only be reserved during Open Hours": "A resource can only be reserved during Open Hours",
    "Selected resources are not available.": "Selected resources are not available.",
  "This resource does not allow booking of recurring meetings.": "This resource does not allow booking of recurring meetings.",
  // Reason
  "You cannot book this resource because your booking request exceeds the available capacity.":
    "You cannot book this resource because your booking request exceeds the available capacity.",
  "If you want to book for additional attendees after sending the invite, remember to send the meeting update to all attendees. Or else, the extra resources will not be booked.":
    "If you want to book for additional attendees after sending the invite, remember to send the meeting update to all attendees. Or else, the extra resources will not be booked.",

    //Expand
  "All day": "All day",
  "{{startDate}} to {{endDate}}": "{{startDate}} to {{endDate}}",
  "Occurs some days from {{startTime}} to {{endTime}} effective {{startDate}} until {{endDate}}": "Occurs some days from {{startTime}} to {{endTime}} effective {{startDate}} until {{endDate}}",
  "Occurs some days from {{startTime}} to {{endTime}} effective {{startDate}}": "Occurs some days from {{startTime}} to {{endTime}} effective {{startDate}}",
  "Occurs some days effective {{startDate}} until {{endDate}}": "Occurs some days effective {{startDate}} until {{endDate}}",
  "Occurs some days effective {{startDate}}": "Occurs some days effective {{startDate}}",
  "Save and Close": "Save and Close",
};
